import React from 'react';
import classNames from 'classnames';
import styles from './Paragraph.module.scss';

export interface ParagraphProps {
	children: React.ReactNode;
	className?: string;
	style?: 'xs' | 'sm' | 'md' | 'lg';
	variant?: 'default' | 'website';
	muted?: boolean;
}

export const Paragraph: React.FC<ParagraphProps> = ({ children, className, style = 'md', variant = 'default', muted }) => (
	<p
		className={classNames(
			styles.Paragraph,
			styles[`Paragraph___${style}`],
			styles[`Paragraph___${variant}`],
			muted ? styles.Paragraph___muted : '',
			className,
		)}
	>
		{children}
	</p>
);
